import React from 'react';
import { Radio } from 'antd';
import { CustomTooltip } from './Tooltip';

export type DeviceTypeRadioValue = 'desktop' | 'mobile' | 'all';

type DeviceTypeRadioSelectorProps = {
  mobileOptimizedEnabled: boolean;
  value?: DeviceTypeRadioValue;
  defaultValue?: DeviceTypeRadioValue;
  onChange?: (value: DeviceTypeRadioValue) => void;
};

export default function DeviceTypeRadioSelector({
  mobileOptimizedEnabled,
  value,
  defaultValue,
  onChange,
}: DeviceTypeRadioSelectorProps) {
  return (
    <div style={{ width: '300px' }}>
      <CustomTooltip
        message={!mobileOptimizedEnabled ? 'Please enable Mobile Optimized Rendering in Advanced Settings' : undefined}
        placement="top"
      >
        <Radio.Group
          style={{ display: 'flex' }}
          // Only spread `value` when it's defined. AntD's Radio.Group treats
          // the presence of the `value` prop (even when `undefined`) as a
          // signal that the component is fully controlled and skips its
          // internal state update on click. Omitting the prop entirely keeps
          // the uncontrolled-with-`defaultValue` path working for parents
          // that don't manage value (e.g. CachedPagesAdd).
          {...(value !== undefined ? { value } : {})}
          defaultValue={defaultValue}
          name="adaptiveType"
          id="adaptiveType"
          disabled={!mobileOptimizedEnabled}
          options={[
            { value: 'desktop', label: 'Desktop' },
            { value: 'mobile', label: 'Mobile' },
            { value: 'all', label: 'Both' },
          ]}
          onChange={(e) => onChange?.(e.target.value)}
        />
      </CustomTooltip>
    </div>
  );
}
